import React from 'react';
import { SlideToggle } from 'components/Global/Buttons';
import { LayoutToggleTitle, LayoutToggleContainer, LayoutToggleWrapper } from './styled.js';

/* toggled === spread view && !toggled === folder view */
const LayoutToggle = ({ toggled, toggleHandler }) => (
  <LayoutToggleWrapper>
    <LayoutToggleContainer>
      <LayoutToggleTitle>Layout</LayoutToggleTitle>
      <SlideToggle type="layout" toggled={toggled} toggleHandler={toggleHandler} />
    </LayoutToggleContainer>
  </LayoutToggleWrapper>
);

export default LayoutToggle;
